import { getUser } from './common';

export const API_URL = 'https://hrapi-i921.onrender.com/api/v1';
// export const API_URL = 'http://localhost:5050/api/v1';
export const USER_ID = getUser.id;
export const USER_TOKEN = getUser.token;
export const SUPPORT_MAIL = 'support@hrmaneja.com';
export const GOOGLE_ANALYTICS_ID = 'G-CNY3YNHV6X';
export const CLOUDINARY_CLOUD_NAME = 'archer';
export const CLOUDINARY_UPLOAD_PRESET = 'hrmaneja-documents';